import React from 'react';
import { useModal } from '@/context/modalContext';
import { useAnalyticsContext } from '@/context/analyticsContext';

type MobilePolicyButtonProps = {
  id: string;
  heading: string;
  modalType: string;
};

const MobilePolicyButton: React.FC<MobilePolicyButtonProps> = ({
  id,
  heading,
  modalType,
}) => {
  const { setModalName } = useModal();
  const { customTrack } = useAnalyticsContext();

  return (
    <button
      id={id}
      type="button"
      onClick={(event) => {
        customTrack({
          event,
          detail: id,
        });
        setModalName(modalType);
      }}
      className="tw-flex tw-min-h-10 tw-flex-1 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-blue-bright-200 tw-bg-white tw-px-4 tw-text-center tw-font-dls tw-text-base tw-font-medium tw-text-link"
    >
      {heading}
    </button>
  );
};

export default MobilePolicyButton;
